/* eslint-disable prefer-promise-reject-errors */
import axios from '../utilities/axios'

const USER_KEY = 'amdreward_user'

async function getUserByToken() {
  try {
    return axios.get('/api/v1/user/me')
  } catch (error) {
    if (!window.location.pathname.includes('login')) {
      window.location.replace('/login')
      clearUserSession()
    }

    return Promise.reject({
      errors: error.response.data,
      statusText: error.response.statusText,
      status: error.response.status,
    })
  }
}

function getSessionToken() {
  return new Promise((resolve, reject) => {
    const user = localStorage.getItem(USER_KEY)
    if (!user) {
      reject('No user stored in the local storage')
    }
    const { token } = JSON.parse(user)
    if (!token) {
      reject('No token for the user in local storage')
    }
    resolve(token)
  })
}

function saveUserSession(user) {
  if (typeof window !== 'undefined') {
    localStorage.setItem(USER_KEY, JSON.stringify(user))
  }
}

function clearUserSession() {
  if (typeof window !== 'undefined') {
    return localStorage.removeItem(USER_KEY)
  }
}

async function login(email, password, captchaToken) {
  const response = await axios.post('/auth/local', { email, password, captchaToken })
  if (response && response.token) {
    // store user details and jwt token in local storage to keep user logged in between page refreshes
    saveUserLogin(response.user)
    saveUserSession(response)
  }
  return response
}

function logout() {
  // remove user from local storage to log user out
  clearUserSession()
}

function getById(id) {
  return axios.get(`/users/${id}`)
}

async function register(user, captchaToken) {
  return axios.post('/auth/local/register', { user, captchaToken })
}

function passwordResetRequest(email) {
  return axios.post('/auth/local/password-reset-request', email)
}

function resetPassword(body) {
  return axios.post('/auth/local/set-password', body)
}

function changePassword(data, captchaToken) {
  return axios.post('/api/v1/user/change-password', { ...data, captchaToken })
}

function changeEmail(body) {
  return axios.post('/api/v1/user/change-email', body)
}

function verifyEmail(body) {
  return axios.post('/auth/local/verify-email-validate', body)
}

function verifyPhoneNumber(body) {
  return axios.post('/auth/local/verify-phone-validate', body)
}

function changePhoneNumber(body) {
  return axios.post('/api/v1/user/change-phone-number', body)
}

function resendVerifyEmailCode() {
  return axios.post('/auth/local/verify-email')
}

function resendVerifyPhoneCode() {
  return axios.post('/auth/local/verify-phone')
}

function deactivate(user) {
  return axios.post('/api/v1/user/deactivate', user)
}

function update(user, captchaToken) {
  return axios.put('/api/v1/user', { user, captchaToken })
}

function saveUserLogin(user) {
  return axios.post('/auth/local/save-user-login', { user })
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return axios.delete(`/users/${id}`)
}

export default {
  getUserByToken,
  getSessionToken,
  saveUserSession,
  saveUserLogin,
  removeSessionStorage: clearUserSession,
  passwordResetRequest,
  resetPassword,
  verifyPhoneNumber,
  verifyEmail,
  resendVerifyEmailCode,
  resendVerifyPhoneCode,
  deactivate,
  login,
  logout,
  register,
  getById,
  update,
  delete: _delete,
  changePassword,
  changeEmail,
  changePhoneNumber,
}
